import { getPokedexByGen } from '~/data/pokedex'
import type { useInventoryStore } from '~/stores/useInventoryStore'
import type { usePlayerStore } from '~/stores/usePlayerStore'

const POKEDEX_MASTER_GEN_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9] as const

type PlayerStore = ReturnType<typeof usePlayerStore>
type InventoryStore = ReturnType<typeof useInventoryStore>

/** Slugs possédés pour la complétion région — aligné page Pokédex (formes normales). */
export function ownedNormalPokedexSlugs(collection: InventoryStore['collection']): Set<string> {
  return new Set(collection.filter((p) => !p.isShiny).map((p) => p.slug))
}

/**
 * Attribue les charmes chroma / `completedPokedexGens` manquants quand le Pokédex régional est complet.
 * Retourne `changed` si au moins une génération vient d’être marquée complète.
 */
export function reconcilePokedexCompletion(
  player: PlayerStore,
  inventory: InventoryStore,
): { changed: boolean; newlyCompleted: number[] } {
  const owned = ownedNormalPokedexSlugs(inventory.collection)
  const newlyCompleted: number[] = []
  const maxGen = Math.min(9, Math.max(1, Math.floor(Number(player.currentGeneration) || 1)))

  for (let gen = 1; gen <= maxGen; gen++) {
    if (player.completedPokedexGens.includes(gen)) continue
    const genPokemon = getPokedexByGen(gen)
    if (genPokemon.length > 0 && genPokemon.every((p) => owned.has(p.slug))) {
      player.completedPokedexGens.push(gen)
      player.shinyCharms = Math.max(0, Math.floor(Number(player.shinyCharms) || 0)) + 1
      newlyCompleted.push(gen)
    }
  }

  player.pokedexMaster = POKEDEX_MASTER_GEN_IDS.every((g) => player.completedPokedexGens.includes(g))

  return { changed: newlyCompleted.length > 0, newlyCompleted }
}
